import React, { Component } from 'react';
import { ReactComponent as LinkedIn } from './img/linkedin.svg';

export default class LinkedInLinkIcon extends Component {
  render() {
    return (
      <a href="https://www.linkedin.com/company/the-black-tux"
        target="_blank"
        rel="noopener noreferrer"
        className="linkedin">
        <LinkedIn />
      </a>
    );
  }
}
